import { useNavigate } from "react-router-dom";
import { eliminarCookies } from "../../../../utils/helpers";
import "./PortalHeader.css"
import { _AbstractAccount, _Affiliate, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useRef, useState } from "react";
import { usePortal } from "../../hook/usePortalState";
import { ValidationOtp } from "../../../../modules/theme/Component/ValidationOTP/ValidationOtp";
import { toast } from "react-toastify";
import { Modal } from "../../../../modules/theme/Component/Modal";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { configPortal } from "../../../../configPortal";

interface Props {
    setIsLogged: any;
}

export const PortalHeader = ({ setIsLogged }: Props) => {

    const { instance } = useDataBean(_AbstractAccount);
    const aff = useDataBean(_Affiliate);

    const [user, setUser] = useState<any>({});
    const { setViewMenu, viewMenu, isMovil } = usePortal();
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const portalMenus: number = configPortal.MENUS_PORTAL ?? 1;

    useEffect(() => {
        setUser(_single.getAccount());
        if (portalMenus == 1) {
            getAffiliate(_single.getAccountID());
        }
        console.log(_single.getAccount());
    }, []);

    const navigate = useNavigate();

    const logout = () => {
        navigate('/');
        sessionStorage.clear();
        eliminarCookies();
        setIsLogged(false);
        window.location.reload();
    }

    const navigateTO = (parameter: string) => {
        navigate(`/portal/home/${parameter}`);
    }

    const ButtoAction = () => {
        setViewMenu(!viewMenu)
    }

    const getAffiliate = (idAccount: number) => {

        const Props = { IDAccount: idAccount };
        aff.instance.getAffiliateCatalogPorPropiedades(Props, null).then(resp => {
            if (resp.length > 0) {
                _single.startSessionAffiliate(resp[0].DataBeanProperties);
            } else {
                console.error("No se encontraron datos del usuario");
            }
        }).catch(err => {
            console.error(err);
        });
    };

    const updatePassword = () => {
        if (!passwordValidation.allValid) {
            toast.error("La contraseña no cumple con los requisitos")
        } else {
            instance.activateUserAccountLocal(_single.getAccountID(), JSON.stringify(_single.getAccount().Nit), password).then(
                (resp) => {
                    toast.success("Contraseña actualizada correctamente")
                    setModal({ ...modal, view: false });
                    setPassword("");
                }
            ).catch(
                (err) => {
                    toast.error("Error al actualizar la contraseña")
                }
            )
        }
    }

    const otpValidator = useRef<any>(null);
    const [password, setPassword] = useState<string>("");
    const [password2, setPassword2] = useState<string>("");
    const [modal, setModal] = useState<any>({ name: "Actualizar Contraseña", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });

    const [passwordValidation, setPasswordValidation] = useState({
        minLength: false,
        upperCase: false,
        lowerCase: false,
        number: false,
        specialChar: false,
        passwordsMatch: false,
        allValid: false
    });

    useEffect(() => {
        const validations = {
            minLength: password.length >= 8,
            upperCase: /[A-Z]/.test(password),
            lowerCase: /[a-z]/.test(password),
            number: /[0-9]/.test(password),
            specialChar: /[^A-Za-z0-9]/.test(password),
            passwordsMatch: password === password2
        };

        setPasswordValidation({
            ...validations,
            allValid: Object.values(validations).every(v => v === true)
        });
    }, [password, password2]);


    return (
        <header className="header-container">
            <div className="left-container">
                {isMovil &&
                    <button type="button" className={`btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none`} id="topnav-hamburger-icon" onClick={ButtoAction}>
                        <span className={`hamburger-icon ${viewMenu ? "open" : ""}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </button>
                }
            </div>
            <div className="right-container">
                <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" id="page-header-notifications-dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                    <i className="bx bx-bell fs-22"></i>
                    {/* <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">3<span className="visually-hidden">unread messages</span></span> */}
                </button>
                <div className="dropdown ms-sm-3 header-item topbar-user" style={{ height: "50px" }}>
                    <button type="button" className="btn shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="d-flex align-items-center">
                            <img className="rounded-circle header-profile-user" src="assets/images/core/defaultUser.webp" alt="Header Avatar" />
                            <span className="text-start ms-xl-2">
                                <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{user.Name1}</span>
                                {/* <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">Founder</span> */}
                            </span>
                        </span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end" >
                        {/* <h6 className="dropdown-header">Welcome Anna!</h6> */}
                        <a className="dropdown-item" onClick={() => { navigateTO("personal-info") }} ><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Perfil</span></a>
                        <a className="dropdown-item" onClick={() => { navigateTO("mesagges") }} ><i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Mensajes</span></a>
                        <a className="dropdown-item" onClick={() => {
                            if (otpValidator.current) {
                                otpValidator.current.openOTPModal("Validacion de Identidad")
                            }
                        }} >
                            <i className="mdi mdi-shield-lock-open-outline text-muted fs-16 align-middle me-1" />
                            <span className="align-middle">Cambiar Contraseña</span>
                        </a>
                        {/* <a className="dropdown-item" href="apps-tasks-kanban.html"><i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Taskboard</span></a>
                        <a className="dropdown-item" href="pages-faqs.html"><i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Help</span></a> */}
                        <div className="dropdown-divider"></div>
                        {/* <a className="dropdown-item" href="pages-profile.html"><i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Balance : <b>$5971.67</b></span></a> */}
                        {/* <a className="dropdown-item" href="pages-profile-settings.html"><span className="badge bg-soft-success text-success mt-1 float-end">New</span><i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Settings</span></a> */}
                        {/* <a className="dropdown-item" href="auth-lockscreen-basic.html"><i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span></a> */}
                        <a className="dropdown-item" onClick={() => { logout() }}><i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span className="align-middle" data-key="t-logout">Cerrar Sesión</span></a>
                    </div>
                </div>
            </div>

            <Modal modal={modal} updateModal={setModal} eventModal={() => { updatePassword() }} >
                <div className="row">
                    <div className="col-md-12 ">
                        <label>Nueva Contraseña</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Ingrese su nueva contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onCopy={(e) => { e.preventDefault(); toast.error("No se puede copiar el texto") }}
                                onPaste={(e) => { e.preventDefault(); toast.error("No se puede pegar el texto") }}
                                onCut={(e) => { e.preventDefault(); toast.error("No se puede cortar el texto") }}
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword(!showPassword)}
                                onCopy={(e) => { e.preventDefault(); toast.error("No se puede copiar el texto") }}
                                onPaste={(e) => { e.preventDefault(); toast.error("No se puede pegar el texto") }}
                                onCut={(e) => { e.preventDefault(); toast.error("No se puede cortar el texto") }}
                            >
                                {showPassword ? "Ocultar" : "Ver"}
                            </button>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <label>Confirmar Contraseña</label>
                        <div className="input-group">
                            <input
                                type={showPassword2 ? "text" : "password"}
                                className="form-control"
                                placeholder="Confirme su nueva contraseña"
                                value={password2}
                                onChange={(e) => setPassword2(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword2(!showPassword2)}
                            >
                                {showPassword2 ? "Ocultar" : "Ver"}
                            </button>
                        </div>
                    </div>

                    <div className="mt-3 text-start">
                        <ul className="list-unstyled small">
                            <li style={{ color: passwordValidation.minLength ? "green" : "red" }}>
                                {passwordValidation.minLength ? "✔️" : "❌"} Mínimo 8 caracteres
                            </li>
                            <li style={{ color: passwordValidation.upperCase ? "green" : "red" }}>
                                {passwordValidation.upperCase ? "✔️" : "❌"} Al menos una letra mayúscula
                            </li>
                            <li style={{ color: passwordValidation.lowerCase ? "green" : "red" }}>
                                {passwordValidation.lowerCase ? "✔️" : "❌"} Al menos una letra minúscula
                            </li>
                            <li style={{ color: passwordValidation.number ? "green" : "red" }}>
                                {passwordValidation.number ? "✔️" : "❌"} Al menos un número
                            </li>
                            <li style={{ color: passwordValidation.specialChar ? "green" : "red" }}>
                                {passwordValidation.specialChar ? "✔️" : "❌"} Al menos un carácter especial
                            </li>
                            <li style={{ color: passwordValidation.passwordsMatch ? "green" : "red" }}>
                                {passwordValidation.passwordsMatch ? "✔️" : "❌"} Las contraseñas coinciden
                            </li>
                        </ul>
                    </div>
                </div>
            </Modal>


            <ValidationOtp onValidate={() => { setModal({ ...modal, view: true }) }} ref={otpValidator} />
        </header>
    )
}